import buildPropertyHeading from './buildPropertyHeading';
import { PHOTO_ALT_DISABLED_LOCALES } from '../../../constants';

const buildCardPhotoAlt = ({ property, locale, translate }) => {
  if (PHOTO_ALT_DISABLED_LOCALES.includes(locale) || !property.address || !property.property_type) return '';

  return buildPropertyHeading({
    propertyType: translate('propertyTypes', property.property_type)(),
    searchOption: property.search_option,
    address: property.address,
    locale,
    translate
  });
};

export default buildCardPhotoAlt;
